document.addEventListener('DOMContentLoaded', function () {
  const followButton = document.querySelector('[data-follow-designer]');
  if (!followButton) return;

  const endpoint = followButton.dataset.followEndpoint || 'https://thetagbk.vercel.app/api/proxy';
  const entityType = resolveEntityType(followButton.dataset.followType);
  const entityHandle = followButton.dataset.followHandle;
  const customerEmail = followButton.dataset.customerEmail || '';
  const normalizedCustomerEmail = customerEmail.trim().toLowerCase();
  const firstName = followButton.dataset.customerFirstName || '';
  const lastName = followButton.dataset.customerLastName || '';
  const container = followButton.closest('.CollectionInformation__DesginerFollow') || document;

  if (container && container.style) {
    container.style.display = 'flex';
    container.style.flexDirection = 'column';
    container.style.alignItems = 'center';
  }

  if (!entityType || !entityHandle) {
    followButton.setAttribute('disabled', 'disabled');
    return;
  }

  let isFollowing = false;
  let hasRemoteState = false;
  let isLoading = false;
  let lastSyncErrorMessage = '';

  const statusMessage = document.createElement('p');
  statusMessage.className = 'FollowStatusMessage';
  statusMessage.style.margin = '0';
  statusMessage.style.fontSize = '12px';
  statusMessage.style.minHeight = '0';
  statusMessage.style.display = 'block';
  statusMessage.style.textAlign = 'center';
  container.appendChild(statusMessage);
  setupButtonContent();

  if (!normalizedCustomerEmail) {
    window.location.href = '/account/login';
    return;
  }

  setLoading(true);
  initializeRemoteState();

  followButton.addEventListener('click', async function (event) {
    event.preventDefault();
    if (isLoading) return;

    if (!hasRemoteState) return;

    const method = isFollowing ? 'DELETE' : 'POST';
    const payload = {
      email: normalizedCustomerEmail,
      type: entityType,
      handle: entityHandle
    };

    if (!isFollowing) {
      if (firstName) payload.firstName = firstName;
      if (lastName) payload.lastName = lastName;
    }

    setLoading(true);

    try {
      const response = await fetch(endpoint, {
        method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const isSuccess = response.ok;
      if (!isSuccess) {
        let errorBody = null;
        try {
          errorBody = await response.json();
        } catch (parseError) {
          errorBody = null;
        }
        const apiErrorMessage = extractApiErrorMessage(errorBody);
        setMessage(apiErrorMessage || resolveErrorMessage(response.status, errorBody), 'error');
        return;
      }

      const synced = await syncFollowState(normalizedCustomerEmail);
      if (!synced) {
        disableFollowButton('Could not verify follow status.');
        return;
      }
      setMessage('', 'idle');
    } catch (error) {
      setMessage('Could not connect to the server.', 'error');
    } finally {
      setLoading(false);
    }
  });

  function setLoading(state) {
    isLoading = state;
    followButton.disabled = state || !hasRemoteState;
    followButton.setAttribute('aria-busy', state ? 'true' : 'false');
    toggleButtonParts(state);
    if (state) {
      followButton.classList.add('ButtonFollow--loading');
      setMessage('', 'idle');
      return;
    }
    followButton.classList.remove('ButtonFollow--loading');
    updateState();
  }

  function setMessage(message, type) {
    statusMessage.textContent = message || '';
    statusMessage.dataset.status = type || 'idle';
    statusMessage.style.marginTop = message ? '8px' : '0';
  }

  function resolveErrorMessage(status, errorBody) {
    if (status === 400) return 'Required data is missing.';
    if (status === 404) {
      const apiMessage = (errorBody && (errorBody.message || errorBody.error || '')).toString().toLowerCase();
      if (apiMessage.includes('list') || apiMessage.includes('lista')) {
        return 'Invalid or missing list.';
      }
      return 'Endpoint not found. Check App Proxy.';
    }
    if (status === 500) return 'Internal error. Try again.';
    if (status === 503) return 'Service unavailable. Try again later.';
    return 'Internal error. Try again.';
  }

  function extractApiErrorMessage(errorBody) {
    if (!errorBody || typeof errorBody !== 'object') return '';
    const errorText =
      (typeof errorBody.error === 'string' && errorBody.error.trim()) ||
      (typeof errorBody.message === 'string' && errorBody.message.trim()) ||
      '';
    if (errorText) return errorText;
    return '';
  }

  function updateState() {
    if (!hasRemoteState) {
      setButtonLabel('Follow');
      return;
    }

    if (isFollowing) {
      setButtonLabel('Unfollow');
      followButton.classList.add('ButtonFollow--followed', 'Button--primary', 'Button--sm');
      followButton.style.border = 'none';
    } else {
      setButtonLabel('Follow');
      followButton.classList.remove('ButtonFollow--followed', 'Button--primary', 'Button--sm');
      followButton.style.border = '1px solid var(--tg-compontent-button-outline-border-color)';
    }
  }

  async function syncFollowState(email) {
    if (!email) return false;

    try {
      const statusUrl = buildStatusUrl(email);
      const response = await fetch(statusUrl, { method: 'GET' });
      if (!response.ok) {
        let errorBody = null;
        try {
          errorBody = await response.json();
        } catch (parseError) {
          errorBody = null;
        }
        lastSyncErrorMessage = extractApiErrorMessage(errorBody) || resolveErrorMessage(response.status, errorBody);
        return false;
      }

      const data = await response.json();
      const remoteIsFollowing = extractFollowingState(data);
      if (typeof remoteIsFollowing !== 'boolean') {
        lastSyncErrorMessage = 'Could not verify follow status.';
        return false;
      }

      isFollowing = remoteIsFollowing;
      hasRemoteState = true;
      lastSyncErrorMessage = '';
      updateState();
      return true;
    } catch (error) {
      hasRemoteState = false;
      lastSyncErrorMessage = 'Could not connect to the server.';
      return false;
    }
  }

  function buildStatusUrl(email) {
    const url = new URL(endpoint, window.location.origin);
    url.searchParams.set('email', email);
    url.searchParams.set('type', entityType);
    url.searchParams.set('handle', entityHandle);
    url.searchParams.set('handles', entityHandle);
    return url.toString();
  }

  function extractFollowingState(data) {
    if (!data || data.success !== true) return null;

    if (typeof data.isFollowing === 'boolean') {
      return data.isFollowing;
    }

    if (Array.isArray(data.results)) {
      const match = data.results.find(function (item) {
        return item && item.handle === entityHandle;
      });
      if (match && typeof match.isFollowing === 'boolean') {
        return match.isFollowing;
      }
    }

    return null;
  }

  function resolveEntityType(datasetType) {
    if (datasetType === 'designer' || datasetType === 'influencer') {
      return datasetType;
    }

    const path = (window.location && window.location.pathname ? window.location.pathname : '').toLowerCase();
    const bodyClasses = (document.body && document.body.className ? document.body.className : '').toLowerCase();

    if (path.includes('influencer') || bodyClasses.includes('influencer')) return 'influencer';
    if (path.includes('designer') || bodyClasses.includes('designer')) return 'designer';

    return '';
  }

  async function initializeRemoteState() {
    const synced = await syncFollowState(normalizedCustomerEmail);
    setLoading(false);

    if (!synced) {
      disableFollowButton(lastSyncErrorMessage || 'Could not verify follow status.');
    }
  }

  function disableFollowButton(message) {
    hasRemoteState = false;
    followButton.disabled = true;
    followButton.classList.remove('ButtonFollow--loading');
    followButton.setAttribute('aria-busy', 'false');
    toggleButtonParts(false);
    setButtonLabel('Follow');
    setMessage(message || '', 'error');
  }

  function setupButtonContent() {
    if (
      followButton.querySelector('.ButtonFollow__Label') &&
      followButton.querySelector('.ButtonFollow__Spinner')
    ) {
      return;
    }

    followButton.innerHTML = '';

    const label = document.createElement('span');
    label.className = 'ButtonFollow__Label';
    label.textContent = 'Follow';

    const spinner = document.createElement('span');
    spinner.className = 'ButtonFollow__Spinner';
    spinner.setAttribute('aria-hidden', 'true');

    followButton.appendChild(label);
    followButton.appendChild(spinner);
  }

  function setButtonLabel(text) {
    const label = followButton.querySelector('.ButtonFollow__Label');
    if (label) {
      label.textContent = text;
      return;
    }
    followButton.textContent = text;
  }

  function toggleButtonParts(isButtonLoading) {
    const label = followButton.querySelector('.ButtonFollow__Label');
    const spinner = followButton.querySelector('.ButtonFollow__Spinner');

    if (label) {
      label.style.visibility = isButtonLoading ? 'hidden' : 'visible';
    }
    if (spinner) {
      spinner.style.display = isButtonLoading ? 'inline-flex' : 'none';
    }
  }
});
